import { render, staticRenderFns } from "./SeminarInvite.vue?vue&type=template&id=18ca9cd8&scoped=true&"
import script from "./SeminarInvite.vue?vue&type=script&lang=js&"
export * from "./SeminarInvite.vue?vue&type=script&lang=js&"
import style0 from "./SeminarInvite.vue?vue&type=style&index=0&id=18ca9cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ca9cd8",
  null
  
)

export default component.exports